import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { UserInfoService } from 'fines-portal/shared/api/data-access/user-info';
import { RouterService } from 'fines-portal/shared/router/data-access/router';
import { map } from 'rxjs';
import { LogService } from 'shared/core/data-access/log';

export const unauthenticatedGuard = (() => {
    const userInfoService = inject(UserInfoService);
    const routerService = inject(RouterService);
    const logService = inject(LogService);

    logService.log('Trying to access unauthenticated section');
    return userInfoService.getUserInfo().pipe(
        map((userInfo) => {
            if (userInfo) {
                logService.log('User is logged in -> redirect to fine detail');
                routerService.fine(userInfo.fine).goTo();
                return false;
            } else {
                logService.log('User is not logged in -> allow');
                return true;
            }
        }),
    );
}) satisfies CanMatchFn;
